import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';

export const CogniteSourceableModel = z.object({
  ...InstanceIdType.shape,

  sourceId: z.string().optional().describe('Identifier from the source system'),
  sourceContext: z
    .string()
    .optional()
    .describe(
      'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
    ),
  source: z.string().optional().describe('Direct relation to a source system'),
  sourceCreatedTime: z.coerce
    .date()
    .optional()
    .describe('When the instance was created in source system (if available)'),
  sourceUpdatedTime: z.coerce
    .date()
    .optional()
    .describe('When the instance was last updated in the source system (if available)'),
  sourceCreatedUser: z
    .string()
    .optional()
    .describe(
      'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
  sourceUpdatedUser: z
    .string()
    .optional()
    .describe(
      'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
});

/** @public */
export type CogniteSourceableModelInput = z.input<typeof CogniteSourceableModel>;
/** @public */
export type CogniteSourceableModelOutput = z.output<typeof CogniteSourceableModel>;
